import { CustomPagination } from 'components';
import { UserContext } from 'context';
import React, { useEffect, useState, useContext, useMemo, useRef } from 'react';
import { constant } from 'constants/constant';
import './masterDetails.css'
import { AddressBookDetails, ConsigneeDetails, ConsignorDetails, DriverDetails, SupplierDetails, UnitDetails } from 'pages';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import StorageService from 'utils/StorageServices/StorageServices';
import { getConsignorListData } from '_services/accountsServices/consignorServices';
import { getSupplierListData } from '_services/accountsServices/supplierServices';
import toast from 'react-hot-toast';
import { getAddressBookListData } from '_services/accountsServices/addressBookService';
import { getUnitListData } from '_services/accountsServices/unitServices';
import { getConsigneeListData } from '_services/accountsServices/consigneeServices';
import { getOwnDriverListData } from '_services/accountsServices/ownDriverServices';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const MasterDetails = () => {

    const { mastersChild, masterDetailsList, setMasterDetailsList, setTRipFilter } = useContext(UserContext);
    const location = useLocation();
    const navigate = useNavigate();
    const loadingBarRef = useRef(null);
    let { id } = useParams();
    const query = useQuery();

    const qType = +query.get('type');
    const qTab = query.get('tab') || 1;
    const qSearch = query.get('search') || '';
    const qOffset = +query.get('offset');
    const qTotalRecord = query.get('total_record') || 0;

    console.log('offset', qOffset)

    const itemsPerPage = 25;
    const dynamicList = masterDetailsList?.list;
    const dynamicDetails = masterDetailsList?.details;

    const handlerFunction = (value, type) => {
        if (type === 1) {
            const params = new URLSearchParams(location.search);
            params.set('tab', qTab);
            navigate(`/account/consignor/details/${value?._id}?${params.toString()}`);
        }
        if (type === 2) {
            const params = new URLSearchParams(location.search);
            params.set('tab', qTab);
            navigate(`/account/supplier/details/${value?._id}?${params.toString()}`);

            setTRipFilter((pre) => ({
                ...pre,
                supplier_id: value?._id || '',
                supplier_name: value?.name || ''
            }))
        }
        if (type === 3) {
            const params = new URLSearchParams(location.search);
            params.set('tab', qTab);
            navigate(`/address_book/details/${value?._id}?${params.toString()}`);
        }
        if (type === 4) {
            const params = new URLSearchParams(location.search);
            params.set('tab', qTab);
            navigate(`/account/unit/details/${value?._id}?${params.toString()}`);
        }
        if (type === 5) {
            const params = new URLSearchParams(location.search);
            params.set('tab', qTab);
            navigate(`/account/consignee/details/${value?._id}?${params.toString()}`);
        }
        if (type === 6) {
            const params = new URLSearchParams(location.search);
            params.set('tab', qTab);
            navigate(`/account/driver/details/${value?._id}?${params.toString()}`);
        }
        setMasterDetailsList((s) => ({ ...s, details: value }));
        setTRipFilter((pre) => ({
            ...pre,
            supplier_id: '',
            supplier_name: ''
        }))
    }

    const getDataConsignorList = async (offset = "") => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                limit: 25,
                offset: offset ? offset : +qOffset,
                search: qSearch,
                status: 1,
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
            }
            const res = await getConsignorListData(object);
            if (res?.responseCode == 200) {
                let element = res?.data?.consignor_list?.find((el) => el?._id === id);
                setMasterDetailsList((s) => ({ ...s, list: res?.data?.consignor_list, details: element }));

                const params = new URLSearchParams(location.search);
                params.set('offset', offset ? offset : +qOffset);
                params.set('total_record', res?.data?.total_record);
                navigate(`${location.pathname}?${params.toString()}`);
            }
        } catch (error) {
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    const getDataSupplierList = async (offset = "") => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                limit: 25,
                offset: offset ? offset : +qOffset,
                search: qSearch,
                status: 1,
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
            };
            const res = await getSupplierListData(object);
            if (res?.responseCode === 200) {
                let element = res?.data?.supplier_list?.find((el) => el?._id === id);
                setMasterDetailsList((s) => ({ ...s, list: res?.data?.supplier_list, details: element }));

                const params = new URLSearchParams(location.search);
                params.set('offset', offset ? offset : +qOffset);
                params.set('total_record', res?.data?.total_record);
                navigate(`${location.pathname}?${params.toString()}`);
            }
        } catch (error) {
            toast.error(error)
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete();
            }
        }
    };

    const getAddressBookList = async (offset = "") => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                limit: 25,
                offset: offset ? offset : +qOffset,
                search: qSearch,
                status: 1,
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
            };
            const res = await getAddressBookListData(object);
            if (res?.responseCode === 200) {

                let element = res.data?.addressbook_list?.find((el) => el?._id === id);
                setMasterDetailsList((s) => ({ ...s, list: res.data?.addressbook_list, details: element }));

                const params = new URLSearchParams(location.search);
                params.set('offset', offset ? offset : +qOffset);
                params.set('total_record', res?.data?.total_record);
                navigate(`${location.pathname}?${params.toString()}`);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete();
            }
        }
    };

    const getDataUnitList = async (offset = "") => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                limit: 25,
                offset: offset ? offset : +qOffset,
                search: qSearch,
                status: 1,
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
            }
            const res = await getUnitListData(object);
            if (res?.responseCode == 200) {

                let element = res?.data?.unit_list?.find((el) => el?._id === id);
                setMasterDetailsList((s) => ({ ...s, list: res?.data?.unit_list, details: element }));

                const params = new URLSearchParams(location.search);
                params.set('offset', offset ? offset : +qOffset);
                params.set('total_record', res?.data?.total_record);
                navigate(`${location.pathname}?${params.toString()}`);
            }
        } catch (error) {
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    const getDataConsigneeList = async (offset = "") => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart();
            }

            let object = {
                limit: 25,
                offset: offset ? offset : +qOffset,
                search: qSearch,
                status: 1,
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
            };
            const res = await getConsigneeListData(object);
            if (res?.responseCode == 200) {

                let element = res?.data?.consignee_list?.find((el) => el?._id === id);
                setMasterDetailsList((s) => ({ ...s, list: res?.data?.consignee_list, details: element }));

                const params = new URLSearchParams(location.search);
                params.set('offset', offset ? offset : +qOffset);
                params.set('total_record', res?.data?.total_record);
                navigate(`${location.pathname}?${params.toString()}`);
            }
        } catch (error) {
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    };

    const getDataOwnDriverList = async (offset = "") => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                limit: 25,
                offset: offset ? offset : +qOffset,
                search: qSearch,
                status: 1,
                driver_type: 1,
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId()
            }
            const res = await getOwnDriverListData(object);
            if (res?.responseCode == 200) {

                let element = res?.data?.driver_list?.find((el) => el?._id === id);
                setMasterDetailsList((s) => ({ ...s, list: res?.data?.driver_list, details: element }));

                const params = new URLSearchParams(location.search);
                params.set('offset', offset ? offset : +qOffset);
                params.set('total_record', res?.data?.total_record);
                navigate(`${location.pathname}?${params.toString()}`);
            }
        } catch (error) {
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    useEffect(() => {
        if (masterDetailsList?.list?.length === 0 && qType === 1) {
            getDataConsignorList();
        }
        if (masterDetailsList?.list?.length === 0 && qType === 2) {
            getDataSupplierList();
        }
        if (masterDetailsList?.list?.length === 0 && qType === 3) {
            getAddressBookList();
        }
        if (masterDetailsList?.list?.length === 0 && qType === 4) {
            getDataUnitList();
        }
        if (masterDetailsList?.list?.length === 0 && qType === 5) {
            getDataConsigneeList();
        }
        if (masterDetailsList?.list?.length === 0 && qType === 6) {
            getDataOwnDriverList();
        }
    }, [])

    const handlePageChange = (page) => {
        if (qType === 1) {
            getDataConsignorList(page);
        }
        if (qType === 2) {
            getDataSupplierList(page);
        }
        if (qType === 3) {
            getAddressBookList(page);
        }
        if (qType === 4) {
            getDataUnitList(page);
        }
        if (qType === 5) {
            getDataConsigneeList(page);
        }
        if (qType === 6) {
            getDataOwnDriverList(page);
        }
    };

    return (
        <>
            <div className='__cmnListDetail'>
                <div className='__cmnListBx_ns'>
                    <div className='__cmnListBx_ns_head'> All {constant.typeName[qType]} </div>

                    <div className="__cmnListBx_ns_content">
                        <div className='__cmnListBx_ns_content_list'>
                            {dynamicList?.map((item, index) => {
                                return (
                                    <React.Fragment key={item?._id}>
                                        <div
                                            key={item?._id}
                                            className={`__cmnInLine ${item?._id === id ? "active" : ""}`}
                                            onClick={() => handlerFunction(item, qType)}
                                        >
                                            <div className='flexMaster_details'>
                                                <span>  {item?.name ? item?.name : 'Name is not available'} </span>
                                                {(qType !== 3 && qType !== 4 && qType !== 5) && <span style={{ color: item.balance < 0 ? '#dc3545' : item.balance > 0 ? '#28a745' : '#1450ec' }}>
                                                    &#x20B9; {Math.abs(item.balance).toFixed(2)}
                                                </span>}
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )
                            })}
                        </div>
                        {dynamicList?.length > 0 && <div className='paginationFt_avt'>
                            <CustomPagination
                                totalItems={qTotalRecord}
                                itemsPerPage={itemsPerPage}
                                currentPage={qOffset}
                                onPageChange={handlePageChange}
                            />
                        </div>}
                    </div>
                </div>

                <div className="__cmnDetailBx">
                    {qType === 1 && <ConsignorDetails />}
                    {qType === 2 && <SupplierDetails />}
                    {qType === 3 && <AddressBookDetails />}
                    {qType === 4 && <UnitDetails />}
                    {qType === 5 && <ConsigneeDetails />}
                    {qType === 6 && <DriverDetails />}
                </div>
            </div>
        </>
    );
};

export default MasterDetails;